import React from 'react';
import { ScheduleItemFragment } from '@graphql/generated';
import { AddScheduleItem } from './components/AddScheduleItem';
import { EditScheduleItem } from './components/EditScheduleItem';

type DefaultScheduleEditorProps = {
  onSuccess: (data: ScheduleItemFragment) => void;
  onError?: (errors: unknown) => void;
  onCancel?: () => void;
  refetch?: string[];
};

export type ScheduleEditorProps = DefaultScheduleEditorProps &
  (
    | {
        mode: 'add';
        eventId: string;
      }
    | {
        mode: 'edit';
        eventId: string;
        scheduleItemId: string;
      }
  );

export const EMPTY_FORM_DATA = {
  name: '',
  description: '',
  startTime: new Date(),
  endTime: new Date(),
  timezone: '',
  virtualEventUrl: null,
  dressCode: '',
  location: null,
  placeId: null,
  showMap: false,
  tags: [],
};

export const ScheduleEditor = (props: ScheduleEditorProps) => {
  const { mode } = props;

  switch (mode) {
    case 'add': {
      return <AddScheduleItem {...props} />;
    }
    case 'edit': {
      return <EditScheduleItem {...props} />;
    }
  }
};
